module.exports = __webpack_public_path__ + "images/logo.96f5166e.svg";